import type { CSSProperties } from 'react';
import { ChevronLeft } from 'lucide-react';

/**
 * BackPill — a "Change game" (or generic back) pill styled IDENTICALLY to the
 * white "How to play" corner pill (see discord/ActivityGameLayout.tsx's
 * HowToPlayCorner / hand+stage LobbyScreen's How-to-play pill): same dark
 * translucent fill, gold hairline, pill radius, Inter 13px/600. A small
 * left-pointing chevron marks it as a back action.
 *
 * Presentational + unpositioned — callers wrap it with their own `position`
 * (fixed/absolute) + safe-area offsets, since the desktop Activity layout and
 * the phone/stage lobby surfaces anchor it differently.
 */
export function BackPill({
  label = 'Change game',
  onClick,
  style,
}: {
  label?: string;
  onClick: () => void;
  style?: CSSProperties;
}) {
  return (
    <button type="button" className="rm-hover" onClick={onClick} style={{ ...backPillBase, ...style }}>
      <ChevronLeft size={15} strokeWidth={2.25} aria-hidden style={{ marginLeft: -4 }} />
      {label}
    </button>
  );
}

/**
 * The corner-pill recipe itself, without the chevron — "How to play", "View
 * roles" and any future lobby corner control take their skin from here rather
 * than re-typing the fill/stroke/type triple a fourth time. Pair it with
 * `className="rm-hover"`; the caller owns positioning.
 */
export const cornerPillStyle: CSSProperties = {
  height: 40,
  padding: '0 16px',
  display: 'inline-flex',
  alignItems: 'center',
  borderRadius: 'var(--radius-pill)',
  background: 'rgba(6,4,6,0.6)',
  border: '1px solid rgba(201,164,78,0.35)',
  color: 'var(--text-primary)',
  fontFamily: 'var(--font-ui)',
  fontWeight: 600,
  fontSize: 13,
  cursor: 'pointer',
};

const backPillBase: CSSProperties = {
  height: 40,
  padding: '0 16px',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  borderRadius: 'var(--radius-pill)',
  background: 'rgba(6,4,6,0.6)',
  border: '1px solid rgba(201,164,78,0.35)',
  color: 'var(--text-primary)',
  fontFamily: 'var(--font-ui)',
  fontWeight: 600,
  fontSize: 13,
  cursor: 'pointer',
  transition:
    'border-color var(--duration-fast, 160ms) var(--ease-standard), background var(--duration-fast, 160ms) var(--ease-standard), filter var(--duration-fast, 160ms) var(--ease-standard), transform var(--duration-fast, 160ms) var(--ease-standard)',
};
